<template>
  <section>
    <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

    <b-field horizontal label="Название">
      <b-input name="subject" expanded v-model="name"></b-input>
    </b-field>

    <b-field horizontal label="WebHook №">
      <b-input type="subject" expanded v-model="webhookId"></b-input>
    </b-field>

    <b-field horizontal>
      <p class="control">
        <b-button label="Сохранить" type="is-primary" @click="create()" :disabled="loading"/>
      </p>
    </b-field>
  </section>
</template>

<script>
import whatsappAccountsRepository from '../../repository/whatsappAccountsRepository';

export default {
  data () {
    return {
      name: null,
      webhookId: null,
      loading: false,
    };
  },
  methods: {
    create () {
      this.loading = true;

      whatsappAccountsRepository.create(this.name, this.webhookId)
      .then(() => this.$router.push({name: 'WhatsAppAccounts'}))
      .then(() => this.$buefy.toast.open('Успешно создано'))
      .catch(() => this.$buefy.toast.open('Ошибка при создании'))
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>